import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
/**
* @class Account
* @classdesc Class definition for record type from model
* @param {Class} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.accounts[0];
* const account = new Account(record);
* @property {number} _id - The id of the Account
* @property {STRING} _number - The number fo the account
* @property {String} _name - The name of the account
* @property {String} _fi - The name of the FI
* @property {bcmsCurrency} _balance - The ending balance of the account
*/
export default class Account extends BCMSRecord{
    _id;   
    _name;  
    _number;   
    _fi;  
    _balance;

    constructor (record){
      super(record);      
    }
  }

Account.define({
    "recordType":"accounts",
    "recordIDProp":"accountID",
    "className" : "Account",
    "recordProperties":[
      /** 
     * @name name
     * @instance
     * @property get {String} - gets name of account
     * @property set {String} - sets the name of the account
     * @memberof Account 
     */
        BCMSRecordProperty.mapToString("id","_id","accountID"),
      /** 
     * @name id
     * @instance
     * @property get {Number} - gets id of the account
     * @property set {String|Number} - sets the id of the account to a number
     * @memberof Account 
     */ 
        BCMSRecordProperty.mapToString("name","_name","accountName"),
      /** 
     * @name number
     * @instance
     * @property get {String} - gets the account number 
     * @property set {String} - sets the account number 
     * @memberof Account 
     */
        BCMSRecordProperty.mapToString("number","_number","accountNumber"),      
     /** 
     * @name fi
     * @instance
     * @property get {String} - returns the name of the fi
     * @property set {String} - sets the the name of the accounts fi
     * @memberof Account 
     */ 
        BCMSRecordProperty.mapToString("fi","_fi","acctInstitution"),
      /** 
     * @name balance
     * @instance
     * @property get {bcmsCurrency} - returns the balance for the account
     * @property set {String|Number|bcmsCurrency} - sets the balance of the account as an intsance of bcmsCurrency.
     * @memberof Account 
     */
        BCMSRecordProperty.mapToCurrency("balance","_balance","accountBalance"),
    ]
})




